export default __webpack_public_path__ + "0b0491b30c023b045a1325bc5558e785.png";